import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  requestedInvestment: null,
  payingOffMortgageDebt: null,
  originationFee: '4.9',
  appraisalCost: 795,
  estimatedHomeValue: null,
  occupancy: null,
  scenario: 'requested',
  inspectionCost: null,
  outstandingMortgageDebt: null,
  estimatedFicoScore: '',
  homePriceAppreciation: '2',
  exchange_rate_adjustment: '0.00',
  annualized_cost_limit: undefined,
  min_investment_override: undefined,
  max_investment_override: undefined,
  pricingVersion: 0,
  adjusted_exchange_rate: '',
  titleSettlementTaxes: 1066,
  applicationProfiles: [],
  nonRegisteredApplicant: '',
  property: null,
  heaExternalID: null,
  exchange_rate_guideline: undefined,
  max_payoff: null,
  total_home_financing_limit: 0,
}

export const CalculationInputsSlice = createSlice({
  name: 'calculationsInputs',

  initialState,

  reducers: {
    setInputs: (state, action) => {
      return action.payload
    },

    setRequestedInvestment: (state, action) => {
      state.requestedInvestment = action.payload
    },
    setPayingOffMortgageDebt: (state, action) => {
      state.payingOffMortgageDebt = action.payload
    },
    setAdjustedExchangeRate: (state, action) => {
      state.adjusted_exchange_rate = action.payload
    },

    resetCalculationsInputsState: () => {
      return initialState
    },
  },
})

export const {
  setInputs,
  setRequestedInvestment,
  setPayingOffMortgageDebt,
  setAdjustedExchangeRate,
  resetCalculationsInputsState,
} = CalculationInputsSlice.actions

export const CalculationInputsReducer = CalculationInputsSlice.reducer
